import React from 'react';

export default function CodeBloc({ children, style }) {
  return <span style={{ padding: '0px 2px', margin: '0px 2px', display: 'inline-block', borderRadius: '4px', backgroundColor: '#f8f8f8', ...style }}>{children}</span>;
}
